module.exports = __webpack_public_path__ + "img/kozhencherry_hsp.a4c58340.jpg";